export default "__VITE_ASSET__CPicT7Ma__"